import React from 'react'
import { IRightButtonADInterface } from './interface'
import Label from '../../home/ad/label'
import { useAdStat } from 'Components/ad'
import { get } from 'lodash'
interface IProps {
  data: IRightButtonADInterface
}

function RightButtonAD({ data }: IProps) {
  const { ref, handleClick } = useAdStat(
    {
      send: 'ad_send_feed_page_top_banner',
      show: 'ad_show_feed_page_top_banner',
      click: 'ad_click_feed_page_top_banner',
    },
    data
  )
  return (
    <>
      <div
        className="right-button-ad"
        ref={ref}
        onClick={() => {
          handleClick()
          setTimeout(() => {
            window.open(data.web_url, '_blank')
          }, 50)
        }}
      >
        <img src={data.image.url} className="ad-image" />
        {data.title && <p className="ad-title">{get(data, 'title', '')}</p>}
        <Label text={data.label} />
      </div>

      <style jsx>
        {`
          .right-button-ad:hover .ad-title {
            color: #ffcd32;
            position: absolute;
            overflow: hidden;
            background-image: none;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            word-break: break-all;
            white-space: normal;
            -webkit-line-clamp: 3;
          }
          .right-button-ad {
            margin-top: 30px;
            width: 380px;
            height: 268px;
            position: relative;
            overflow: hidden;
            border-radius: 2px;
          }
          .right-button-ad:hover .ad-image {
            transform: scale(1.1);
          }
          .right-button-ad:hover .ad-title {
            color: #ffcd32;
          }
          .ad-image {
            width: 100%;
            height: 100%;
            transition: all 0.2s ease-in-out;
          }
          .ad-title {
            position: absolute;
            left: 0;
            right: 0;
            bottom: 12px;
            width: 100%;
            text-align: start;
            color: #ffffff;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            font-size: 16px;
            font-weight: 500;
            min-width: 0;
            bottom: 12px;
            padding: 0 40px 0 12px;
          }
        `}
      </style>
    </>
  )
}

export default RightButtonAD
